/*eslint-disable */
import React, { FC, useState, useRef, useEffect, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";
import { sanitize } from "dompurify";

import styles from "./styles";
import Info from "Assets/images/info_blue.svg";

import PanoPlayer from "Components/PanoPlayer";
import ShareMenuContainer from "Containers/ShareMenu";
import { MapContext } from "Context/MapContext";
import ArrowBack from "Assets/images/arrow_back.svg";

import Close from "Assets/images/modal_close.svg";
import { motion } from "framer-motion";
import Navigate from "Assets/images/navigation_caret.svg";
import clsx from "clsx";

interface Props {
  media: any[];
  selectedIdx: number;
  changeDisplay: (val: any) => void;
  handleMediaClick: any;
}

const PanoViewerSmallViewPort: FC<Props> = (props: Props) => {
  const { media, selectedIdx, changeDisplay } = props;
  const useStyles = createUseStyles(styles);

  const [description, setDescription] = useState(false);
  const [open, setIsOpen] = useState(true);
  const [play, setPlay] = useState(true);
  const { instId, locId } = useContext(MapContext);
  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/panoramas/${instId}/${locId}?id=${media[selectedIdx]?.id}`;

  const theme = useTheme();

  const [fullScreen, setFullScreen] = useState(false);
  const panoRef = useRef(null);

  const classes = useStyles({ theme, ...props, state: { description } });

  const changeFullScreen = (val: boolean) => {
    setFullScreen(val);
  };

  useEffect(() => {
    setFullScreen(false);
    setPlay(true);
  }, [selectedIdx]);

  const changeMode = () => {
    setPlay(!play);
  };

  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "-100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
        onComplete: () => {
          changeDisplay(false);
        },
      },
    },
  };

  return (
    <motion.div
      initial={"closed"}
      variants={animations}
      animate={open ? "open" : "closed"}
      className={classes.viewer}
    >
      <div className={classes.topContainer}>
        <ArrowBack
          onClick={(e: any) => {
            e.stopPropagation();
            setIsOpen(false);
          }}
        />
        <span className={classes.counter}>
          {selectedIdx + 1}/{media.length}
        </span>
        {media[selectedIdx].description && (
          <Info
            onClick={(e: any) => {
              e.stopPropagation();
              setDescription(true);
            }}
          />
        )}
      </div>
      <PanoPlayer
        ref={panoRef}
        play={play}
        changeMode={changeMode}
        fullScreen={fullScreen}
        changeFullScreen={changeFullScreen}
        options={{
          hasEasy: media[selectedIdx]["hasEasy"],
          height: "100%",
          width: "100%",
          path: media[selectedIdx]["path"],
          startFov: media[selectedIdx]["start_fov"],
          startLat: media[selectedIdx]["start_lat"],
          startLon: media[selectedIdx]["start_lon"],
          exit_lat: media[selectedIdx]["exit_lat"],
          exit_lon: media[selectedIdx]["exit_lon"],
          autoRotateSpeed: 0.1,
        }}
        data-testid="pano"
      ></PanoPlayer>
      <div className={classes.videoTitle}>{media[selectedIdx].title}</div>
      <div className={classes.navigate}>
        <div
          className={classes.caret}
          onClick={(e) => {
            e.stopPropagation();
            props.handleMediaClick(selectedIdx - 1);
          }}
        >
          {selectedIdx > 0 && <Navigate />}
        </div>

        <div className={classes.counter}>
          {selectedIdx + 1}/{media.length}
        </div>

        <div
          className={clsx(classes.caret, classes.rotate)}
          onClick={(e) => {
            e.stopPropagation();
            props.handleMediaClick(selectedIdx + 1);
          }}
        >
          {selectedIdx !== media.length - 1 && <Navigate />}
        </div>
      </div>
      {description && (
        <div className={classes.description}>
          <div
            className={classes.closeIcon}
            onClick={(e: any) => {
              e.stopPropagation();
              setDescription(false);
            }}
          >
            <Close />
          </div>
          <div 
            className={classes.descriptionText}
            dangerouslySetInnerHTML={{
              __html: sanitize(media[selectedIdx].description || media[selectedIdx].title, {
                ADD_ATTR: ["target"],
              }),
            }}>
          </div>
        </div>
      )}
      <div>
        <span
          style={{
            cursor: "pointer",
            position: "fixed",
            bottom: "0%",
            right: "5%",
          }}
        >
          <ShareMenuContainer url={shareUrl} svgColor="#FFFFFF" />
        </span>
      </div>
    </motion.div>
  );
};

export default PanoViewerSmallViewPort;
